module.exports = __webpack_public_path__ + "assets/pdf/cycle3_invesment_plan.2338a9b6.pdf";